const USER_TYPE_STUDENT = 1;
const USER_TYPE_ADMIN = 2;
const USER_TYPE_SCHOOL = 3;

export { USER_TYPE_ADMIN, USER_TYPE_STUDENT, USER_TYPE_SCHOOL };
